import { currentWeekStartInTimeZone, toISODateString } from "@/utils/dateUtils";
import { MonDateInput } from "../WeekStepper";

interface TimelineDateSelectorProps {
    value: string;
    onChange: (date: string) => void;
    timeZone: string;
}

export function TimelineDateSelector({
    value,
    onChange,
    timeZone,
}: TimelineDateSelectorProps) {
    const handleThisWeekClick = () => {
        const thisMonday = currentWeekStartInTimeZone(timeZone);
        onChange(toISODateString(thisMonday));
    };

    return (
        <div className="timeline-date-selector">
            <div className="timeline-date-selector__row">
                <span className="timeline-date-selector__label">Scroll to date:</span>
                <MonDateInput
                    value={value}
                    onChange={onChange}
                    autoFocus={false}
                />
                <button
                    type="button"
                    className="timeline-date-selector__today-button"
                    onClick={handleThisWeekClick}
                >
                    This week
                </button>
            </div>
        </div>
    );
}
